export const URLregex =
  /^((https?):\/\/)?(www\.)?[a-z0-9-_]+(\.[a-z-_]{2,}){1,3}(\/[a-zA-Z0-9-_]*)*\/?(\?[a-zA-Z0-9-_.%=&]*)?(#[a-zA-Z0-9-_]*)?$/;
export const URLSlugRegex = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/;
export const twoDigitsRegex = /^\d{2}$/;
